import {useCan} from '@/shared/hooks/use-permissions'
import {useGetTradeName} from '@/modules/products/trade-names/api'
import {useAcknowledgeExpiredBatch} from '@/modules/stocks/batches/api/use-acknowledge-expired-batch'
import {isBatchExpired, isBatchDisposed} from '@/modules/stocks/functions'
import {ResourceDrawerSummary} from '@/shared/components/ui/resource-drawer-summary'
import {useBatchContext} from '@/shared/contexts/batch'
import {Badge, Button, Drawer, Tabs} from '@chakra-ui/react'
import {DrawerBody, DrawerFooter, DrawerHeader} from '@cypro/ui/components'
import {LinkButton} from '@cypro/ui/components/ui/link-button'
import {useTranslate} from '@tolgee/react'
import {LuDatabase, LuTrash} from 'react-icons/lu'
import {BatchDrawerTabsList} from './tabs-list'
import {AboutTab} from './tabs/about'
import {HistoryTab} from './tabs/history'

export function BatchDrawer() {
  const canManageStock = useCan('stock.manage')
  const {t} = useTranslate('common')
  const {batch} = useBatchContext()
  const acknowledgeExpiredBatch = useAcknowledgeExpiredBatch()

  const [tradeName] = useGetTradeName(batch.tradeNameId || '')

  const isExpired = isBatchExpired(batch)
  const isDisposed = isBatchDisposed(batch)

  return (
    <>
      <DrawerHeader>
        <Drawer.Title>{tradeName?.name}</Drawer.Title>
      </DrawerHeader>

      <DrawerBody>
        <ResourceDrawerSummary
          title={batch.lotNumber}
          description={tradeName?.barcodeGtin || tradeName?.nationalId || '-'}
          icon={LuDatabase}
        >
          {isDisposed && (
            <Badge size="sm" variant="subtle" colorPalette="red">
              {t('disposed')}
            </Badge>
          )}
        </ResourceDrawerSummary>

        <Tabs.Root defaultValue="about" spaceY="5" lazyMount>
          <BatchDrawerTabsList />
          <AboutTab />
          <HistoryTab />
        </Tabs.Root>
      </DrawerBody>

      {canManageStock && (
        <DrawerFooter display="flex" justifyContent="flex-end" gap="3">
          {isExpired && !isDisposed && (
            <Button variant="surface" colorPalette="red" onClick={() => acknowledgeExpiredBatch({batchId: batch.id})}>
              <LuTrash />
              {t('dispose_batch')}
            </Button>
          )}
          <LinkButton
            to="/stocks/batches/new"
            search={{batchId: batch.id}}
            colorPalette="cyan"
            data-e2e="edit-batch"
            disabled={isDisposed}
          >
            {t('edit')}
          </LinkButton>
        </DrawerFooter>
      )}
    </>
  )
}
